import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionManagementService, SessionWarning } from 'src/app/services/session-management.service';

@Component({
  selector: 'session-warning-modal',
  templateUrl: './session-warning-modal.html',
  styleUrls: ['./session-warning-modal.scss']
})
export class SessionWarningModalComponent implements OnInit, OnDestroy {
  sessionWarning: SessionWarning = {
    show: false,
    expiresAt: new Date(),
    timeRemaining: '',
    canRefresh: false
  };

  isExtending = false;
  private subscription?: Subscription;

  constructor(
    private sessionManagementService: SessionManagementService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.sessionManagementService.sessionWarning$.subscribe(
      warning => {
        this.sessionWarning = warning;
        this.cdr.detectChanges();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async onExtendSession(): Promise<void> {
    if (this.isExtending) return;
    
    this.isExtending = true;
    const success = await this.sessionManagementService.extendSession();
    
    if (!success) {
      // Show error message or handle failure
      console.error('Failed to extend session');
    }
    
    this.isExtending = false;
    this.cdr.detectChanges();
  }

  onLogout(): void {
    this.sessionManagementService.logout();
  }

  onDismiss(): void {
    // If session is expired and cannot refresh, redirect to login instead of dismissing
    if (this.sessionWarning.timeRemaining === 'expired' && !this.sessionWarning.canRefresh) {
      this.sessionManagementService.logout();
    } else {
      this.sessionManagementService.hideSessionWarning();
    }
  }

  onRelogin(): void {
    this.sessionManagementService.logout();
  }

  get showModal(): boolean {
    return this.sessionWarning.show;
  }

  get timeRemainingClass(): string {
    // Parse time remaining to get minutes for styling
    const timeStr = this.sessionWarning.timeRemaining.toLowerCase();
    if (timeStr.includes('less than 1') || timeStr === '1 minute') {
      return 'text-danger';
    } else if (timeStr.includes('2 minute') || timeStr.includes('3 minute')) {
      return 'text-warning';
    }
    return 'text-info';
  }

  get currentTime(): Date {
    return new Date();
  }
}